/**
 * <EmptyState> — une liste vide, dite une fois (molecule).
 *
 * Une phrase qui donne le geste, une phrase qui dit l'état, et — au besoin — un glyphe.
 *
 * **Pas de champion.** Le livre V13 le range dans ses « jamais » : « une mascotte sur un écran
 * vide, une 404, un dialogue ». Les champions restent là où ils AGISSENT (le bilan, un
 * événement) ; une liste vide ne demande rien à personne.
 *
 * Aucun bouton : les trois écrans en ont déjà un dans la page (« Générer une activité »), et un
 * second appel à l'action ici ferait deux fois le même geste.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Stack } from "../../atoms/containers/Stack"
import { Icon, type IconName } from "../../atoms/icons/Icon"
import { Paragraph } from "../../atoms/typography/Paragraph"
import { Title } from "../../atoms/typography/Title"

/** Le glyphe : plus grand qu'une icône de ligne, plus petit qu'un dessin. */
const ICON_SIZE = 60

export type EmptyStateProps = {
    title: string
    /** La phrase sous le titre — absente, l'état vide tient en un mot. */
    message?: string
    /** Un glyphe au-dessus du titre. Absent, l'état vide est du texte seul. */
    iconName?: IconName
    testID?: string
}

export function EmptyState(props: EmptyStateProps) {
    const { title, message, iconName, testID } = props

    return (
        <Stack gap="3" align="center" justify="center" style={styles.root} testID={testID}>
            {iconName != null && <Icon name={iconName} size={ICON_SIZE} color="text-muted" />}
            <Title center color="text-muted">
                {title}
            </Title>
            {message != null && message !== "" && (
                <Paragraph center color="text-muted">
                    {message}
                </Paragraph>
            )}
        </Stack>
    )
}

const styles = StyleSheet.create((theme) => ({
    root: {
        paddingVertical: theme.spacing["8"],
        paddingHorizontal: theme.spacing["4"],
    },
}))
